import { render, staticRenderFns } from "./HydrologicalDataCards.vue?vue&type=template&id=3bc912fa&scoped=true"
import script from "./HydrologicalDataCards.vue?vue&type=script&lang=js"
export * from "./HydrologicalDataCards.vue?vue&type=script&lang=js"
import style0 from "./HydrologicalDataCards.vue?vue&type=style&index=0&id=3bc912fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc912fa",
  null
  
)

export default component.exports